import React from "react";
import "./style.css";

const Wave = ({
  waveColor,
  linesColor,
  showLines = false,
  className,
  invertY = false,
  invertX = false
}) => {
  return (
    <svg
      preserveAspectRatio="none"
      className={`w-full fill-current text-${waveColor} h-18 md:h-24 lg:h-32 xl:h-40 ${
        invertX ? "invertX" : ""
      } ${invertY ? "invertY" : ""} ${className}`}
      viewBox="0 0 1440 172"
      fill="currentColor"
    >
      <path
        d="M962.663 172C641.609 172 395.451 8.5 0 8.5V0h1440c-52.09 57.333-220.49 172-477.337 172z"
        fill="currentColor"
      />
      {showLines && (
        <path
          className={`text-${linesColor}`}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M507.068 91.16c-11.771-2.782-22.501-5.552-32.068-8.265l.273-.962c83.701 23.736 256.531 51.856 438.369 53.731C1095.5 137.539 1286.24 113.158 1405.86 32l.56.828c-119.89 81.342-310.9 105.711-492.789 103.836-142.883-1.473-280.219-19.144-373.179-38.173 121.38 28.76 265.568 50.036 410.117 48.548 157.761-1.625 315.921-30.367 445.311-106.057l.51.863c-129.6 75.81-287.95 104.568-445.811 106.194-139.774 1.439-279.199-18.393-398.011-45.694 3.689 1.019 7.407 2.039 11.154 3.059 217.058 54.744 539.798 101.688 819.668-55.426l.49.872C1123.21 197.186 825.453 166.7 610.399 117.65c210.568 52.988 495.041 91.579 772.491-64.173l.49.872c-298.88 167.784-605.875 110.286-819.904 52.023a2476.02 2476.02 0 01-56.473-14.977l.065-.237zm37.599 9.351c1.505.393 3.015.787 4.531 1.179l.032-.115c-1.524-.354-3.046-.708-4.563-1.064z"
          fill="currentColor"
        />
      )}
    </svg>
  );
};

export default Wave;
